var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _vm.showMoreButton ? _c('el-dropdown', { attrs: { "trigger": "click" } }, [_c('pt-button', { attrs: { "type": "ghost", "theme": "primary", "size": "big", "mini": "", "icon": "" } }, [_c('ic-more')], 1), _vm._v(" "), _c('el-dropdown-menu', { staticClass: "more-operate-item", attrs: { "slot": "dropdown" }, slot: "dropdown" }, [_c('el-dropdown-item', [_c('download-all-resources')], 1)], 1)], 1) : _vm._e();
};
var staticRenderFns = [];

export { render, staticRenderFns };